// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__owvBA","content":"TermsOfServicePage_content__2Z6ZK"};